import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ConnectionHistory } from './connection-monitor.component';

@Component({
    selector: 'app-connection-monitor-modal',
    templateUrl: './connection-monitor-modal.component.html',
})
export class ConnectionMonitorModalComponent implements OnInit {
    public uiVersion: string;

    constructor(
        public dialogRef: MatDialogRef<ConnectionMonitorModalComponent>,
        @Inject(MAT_DIALOG_DATA) public responseHistory: ConnectionHistory[],
    ) {
    }

    public ngOnInit(): void {
        this.uiVersion = window['layoutFileVersion'];
    }

    public get apiVersion() {
        return this.responseHistory[0].apiVersion;
    }
}
